import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { RoleEnum } from "types/enums";
import { getHighestTenantRoleGroup } from "utils/getTenantRoleBadge";

export const useRoleLabel = () => {
    const { t } = usePaldockTranslation("common.roles");

    return (role?: string | null) => {
        if (!role) return "-";
        // Admin/Advertiser/Affiliate have several plan-tier variants (e.g. "Admin Free", "Admin
        // Beast") that all collapse to the same group label — everything else falls back to the
        // raw role value, same as before.
        const group = getHighestTenantRoleGroup([role as RoleEnum]);
        return t(group ?? role, { defaultValue: role });
    };
};
